angular.module('tgaAdmin').controller('PlayerListsController', [
  '$scope',
  '$state',
  'playerListService',
  'hubService',
  function ($scope, $state, playerListService, hubService) {
    $scope.data = {
      alerts: [],
    };

    $scope.viewmodel = {};

    $scope.initialize = function () {
      $scope.loading = true;
      if ($state.params.hub_id) {
        hubService.getHub($state.params.hub_id);
      }
      playerListService.getPlayerLists().then((playerLists) => {
        $scope.viewmodel.playerLists = playerLists;
        $scope.loading = false;
      });
    };

    $scope.actions = {
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
